import { SyuugyouKisokuApi } from "@/api/SyuugyouKisokuApi";

export class SyuugyouKisokuService {
  
  /**
   * 所属に応じた就業規則一覧を取得します（オプション値）
   * @returns 所属に応じた就業規則（権限によりシステム上のすべての就業規則）
   */
   public async getKisokuOptionsBySyozoku() {
    const api = new SyuugyouKisokuApi()
    try {
      return await api.getKisokuOptionsBySyozoku()
    } catch (e) {
      throw e
    }
  }
  public async getKisokuPdf(path: string) {
   const api = new SyuugyouKisokuApi()
   try {
     return await api.getKisokuPdf(path)
   } catch (e) {
     throw e
   }
 }
}
